export enum SafetyEventFiltersTypes {
  DATE = 'DATE',
  CATEGORY = 'CATEGORY',
}

export const SafetyEventFiltersOptions = [
  { value: SafetyEventFiltersTypes.DATE, label: 'Date' },
  { value: SafetyEventFiltersTypes.CATEGORY, label: 'Category' },
]

export const SAFETY_EVENT_FILTERS_TOOLBAR_HEIGHT = 40

export type SelectedSafetyEventFiltersType = Record<SafetyEventFiltersTypes, boolean>

export type SelectedSafetyEventFiltersValuesType = Record<
  SafetyEventFiltersTypes.CATEGORY,
  string | 'ALL' | undefined
>
